import ApiInvoiceNumberSettingsService from "app/Service/Client/ApiInvoiceNumberSettingsService"
import ClientService, {SubscribeClient} from "app/Service/Client/ClientService"
import ToolbarView from "app/WebView/Toolbar/ToolbarView"
import {ToolbarButtons} from "app/WebView/Toolbar/ToolbarView.model"
import {Module} from "const/Module"
import React from "react"
import {useMemo} from "react"
import {useTranslation} from "react-i18next"

function InvoiceNumberSettingsButtons() {

  const {t} = useTranslation("ContentSettings.InvoiceSettings", {keyPrefix: 'toolbar'})

  const {editInvoiceNumberSettings, invoiceNumberSettings, clearClientEdit} = ClientService([
    SubscribeClient.invoiceNumberSettings
  ], 'InvoiceNumberSettingsButtons')

  const {lockSettings, patchSettings} = ApiInvoiceNumberSettingsService()

  const buttons = useMemo(() => {
    const buttons: ToolbarButtons = {
      second: [{
        id: Module.invoiceNumberSettings,
        type: 'save',
        disabled: undefined === editInvoiceNumberSettings && !!invoiceNumberSettings,
        onClick: () => {
          patchSettings().then()
        }
      }],
      third: [{
        id: Module.invoiceNumberSettings,
        type: 'cancel',
        disabled: undefined === editInvoiceNumberSettings && !!invoiceNumberSettings,
        onClick: () => {
          clearClientEdit()
        }
      }],
      fourth: [],
    }

    if (invoiceNumberSettings) {
      buttons.fourth.push({
        id: 'invoiceNumber-lock',
        title: invoiceNumberSettings.locked ? t('unlock') : t('lock'),
        onClick: () => {
          lockSettings(!invoiceNumberSettings.locked).then()
        }
      })
    }

    return buttons
  }, [editInvoiceNumberSettings, invoiceNumberSettings])

  return <ToolbarView buttons={buttons}/>

}

export default InvoiceNumberSettingsButtons
